import * as React from 'react';
import type { TabsProps } from './types';
import cn from '~modules/cn';
import './tabs.scss';

export const Tabs = React.forwardRef<HTMLDivElement, TabsProps>(
    ({ className, children, onChange, type = 'normal' }: TabsProps, ref): JSX.Element => (
        <div ref={ref} className={cn(className, 'tabs-container', `tabs-container-${type}`)}>
            {React.Children.map(children, (child, key) =>
                React.isValidElement(child) ? React.cloneElement(child as React.ReactElement, { key, onChange }) : null
            )}
        </div>
    )
);

Tabs.displayName = 'Tabs';
